export default __webpack_public_path__ + "static/media/3.6cc5b566.png";